import { type GetServerSideProps } from 'next';
import { type SitemapPageProps } from '../../modules/sitemap/@interfaces';
import { getSitemapData } from '../../modules/sitemap';

import { withEnhancedPageHandler } from '../../middlewares/withEnhancedPageHandler';

import { applyCorrelationIdHeader } from '../../utils/server/applyCorrelationIdHeader';

import { SitemapTemplate } from '../../templates';

const Sitemap = (props: SitemapPageProps) => <SitemapTemplate {...props} />;

const getServerSidePropsHandler: GetServerSideProps = async ({ req }) => {
  const customHeaders = applyCorrelationIdHeader(req.headers);

  const props = await getSitemapData({
    customHeaders,
  });

  return {
    props,
  };
};

export const getServerSideProps = withEnhancedPageHandler(
  getServerSidePropsHandler
);

export default Sitemap;
